import PropTypes from "prop-types";
import React from "react";

const Empty = (props) => {
  return (
    <div className="erg-margin-15 text-muted">
      <h3>{props.title}</h3>
      {props.children}
    </div>
  );
};

Empty.defaultProps = {
  children: "No data loaded from server by your query.",
  title: "Empty",
};
Empty.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]),
  title: PropTypes.string,
};

export default Empty;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/Empty.js
 **/